import { useEffect } from 'react';
import { platformApi } from '@/api/platform.api';
import { enabledHeadModuleCodes, getModuleEntryByErpModule } from '@/config/moduleEntries';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';
import { setAccessibleModules, setEnabledModules } from '@/store/authSlice';

/** Keeps launcher module lists in sync with the server (head apps only). */
export function useLauncherModuleSync() {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const user = useAppSelector((s) => s.auth.user);

  useEffect(() => {
    if (!isAuthenticated || !user || user.masterAdmin) return;

    void platformApi
      .listAccessibleModules()
      .then((accessible) => {
        if (accessible.length > 0) {
          dispatch(setAccessibleModules(accessible));
        }
      })
      .catch(() => {});

    void platformApi
      .listModules()
      .then((modules) => {
        const enabled = enabledHeadModuleCodes(
          modules.filter((m) => m.enabled).map((m) => m.module),
        );
        if (enabled.length > 0) {
          dispatch(setEnabledModules(enabled));
        }
      })
      .catch(() => {});
  }, [dispatch, isAuthenticated, user?.userId]);
}

/** Whether the org has subscribed to this head-module app. */
export function isHeadModuleSubscribed(
  module: string,
  enabledModules: string[],
  accessibleModules?: string[],
): boolean {
  const upper = module.toUpperCase();
  if (!getModuleEntryByErpModule(upper)) return false;
  if (accessibleModules?.includes(upper)) return true;
  return enabledModules.includes(upper);
}
